export enum OnboardedGuardVerificationPathType {
  INFORMATION = 'INFORMATION',
  VERIFICATION = 'VERIFICATION',
  SUPPORTING_INFORMATION = 'SUPPORTING_INFORMATION',
}
